import React from "react";
import { captureAndDisplayError, lsSupported } from "../utils";
import { BasicError } from "./_Misc";

interface Props {
  fallback?: any;
}
export class ErrorBoundary extends React.Component<Props> {
  state = {
    hasError: false,
    error: null as null | Error,
    msg: null,
  };
  defaultFallback = "Sorry, an unexpected error occured - refreshing the page may help.";

  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
      error,
      msg: error?.name === "ChunkLoadError" ? "Failed to load component, refreshing the page may help" : null,
    };
  }

  // haven't tested but should work, trying server-side not caching index.html to see if it helps
  // canAttemptReload(): boolean {
  //   if (!lsSupported()) {
  //     return false;
  //   }

  //   const reloadAttemptedKey = "__err_" + import.meta.env.VITE_VERSION + "_1";
  //   let count = 1;

  //   // get the previous value then increment it
  //   try {
  //     count = parseInt(sessionStorage.getItem(reloadAttemptedKey) || "0");
  //     count++;
  //   } catch (error) {
  //     console.warn(error);
  //     count = 1;
  //   }

  //   if (count > 5) {
  //     return false;
  //   }

  //   // store the new value
  //   sessionStorage.setItem(reloadAttemptedKey, count.toString());
  //   return true;
  // }

  render() {
    if (!this.state.hasError) return this.props.children;

    try {
      const reloadAttemptedKey = "__err_" + import.meta.env.VITE_VERSION + "_1"; // reload attempted on this app version

      // If it's ChunkLoadError, check to make sure we haven't already attempted to reload.
      // if (this.state.error?.name === "ChunkLoadError" && this.canAttemptReload()) {
      if (this.state.error?.name === "ChunkLoadError" && lsSupported() && !sessionStorage.getItem(reloadAttemptedKey)) {
        // Set key to prevent reload loop.
        sessionStorage.setItem(reloadAttemptedKey, "true");

        // Reload the page, attaching a ?param at end of URL so browser hopefully does not use cached assets.
        window.location.replace(`${window.location.pathname}?${Date.now()}`);
        return;
      }

      return this.props.fallback || <BasicError error={this.state.msg || this.defaultFallback} />;
    } catch (error) {
      if (error instanceof Error) captureAndDisplayError(error, false);
      return <BasicError error={this.state.msg || this.defaultFallback} />;
    }
  }
}

export default ErrorBoundary;
